import * as React from 'react';
import Helper from 'src/support/Helper';
import { useState, useEffect } from 'react';
import SystemAlerts from 'src/component/SystemAlerts';
import System from 'src/helper/system';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import Common from 'src/pages/Cart/Common';
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import noImage from 'src/assets/images/noimage.png'
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import CartRepository from 'src/repository/CartRepository';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const CheckoutMyCart = (props) => {
    const [{ CART_PRODUCT_DATA, CART_PRODUCT_INVENTORY_DATA, CART_DATA }, { initiatedKernelCall, fetch_cart_data }, { }] = useCartStore();
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [__check] = useAxiosIndicatorCheck();
    let cartProductData = JSON.parse(localStorage.getItem('cartProductData'))
    let cartProductInventoryData = JSON.parse(localStorage.getItem('cartProductInventoryData'))
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

    useEffect(() => {
        async function fetchData() {
            await fetch_cart_data()
            setFirstServerCall(false)
        }
        System.alert("Prices are subject to change due to manufacturers’ price increase, change in <b> exchange rate </b> or quoting errors.", 'info', 'checkoutCart');
        fetchData()
    }, []);

    useEffect(() => {
        if (firstServerCall === false && !monitorFunctionCall && CART_DATA?.length && !(__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render)) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
            localStorage.setItem("adobeEventType","cartCheckout");
            let prodDetails = CART_DATA;
            let cartDetails = {
                "cartType" : "checkout"
            }
            if(Object.keys(prodDetails).length){
                HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
            }
        }
    }, [CART_DATA, __check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render])

    const getAvailableQuantity = (v) => {
        if (v && v?.scheduleDetails?.length) {
            let sum = 0;
            v.scheduleDetails.forEach(ele => {
                sum += ele.quantity;
            });

            let avlQty = v.quantity - sum;
            return avlQty
        }
    }

    return (
        <>
            <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button id="collapseTwo" className="accordion-button font-16" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            My Cart
                        </button>
                    </h2>
                    <div id="collapseOne" className={'accordion-collapse collapse in'} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        {latest_system_notification_data.errorModule !== undefined &&
                            latest_system_notification_data.errorModule === 'checkoutCart' &&
                            <div className='blue-alert mt-3 mx-2'>
                                <SystemAlerts />
                            </div>
                        }
                        <div className="accordion-body">
                            <div className="table-responsive">
                                {(__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render) ? <AxiosIndicatorRunTimeLoader /> :
                                    <table className="mycart-table" width="100%">
                                        <tbody>
                                            {CART_DATA?.length > 0 && Object.entries(CART_DATA).length > 0 && Object.entries(CART_DATA).length > 0 &&
                                                CART_DATA.map((v, i) => (
                                                    <tr key={i}>
                                                        <td className="acc-product-img">
                                                            <div className="product-info nopadding">
                                                                <span className='checkout-item-count'>Item: {i + 1}</span>
                                                                <div className="product-img sect-1 text-center">
                                                                    <img src={(Helper.valueIsNotNull(v.assetURL))
                                                                        ? v.assetURL
                                                                        : noImage} alt='Product' />
                                                                </div>
                                                            </div>
                                                            <div className="prod-option-icon sect-2">
                                                                <div className="d-flex justify-content-start">
                                                                    <ProductLegends
                                                                        single_product={cartProductData && cartProductData[v.itemNumber]}
                                                                        onlyIcon={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="acc-product-name">
                                                            <>
                                                                <strong>{v.ERPMFRPartNumber}</strong> <br />
                                                                {v.manufacturerName !== undefined &&
                                                                    <div>
                                                                        <span> by </span>
                                                                        {v.manufacturerName ? v.manufacturerName : ''}
                                                                    </div>
                                                                }
                                                                <strong>{v.cpnTypeName === 'CPN' ? v.cpn : (v.manualCPN === '*' ? '' : v.manualCPN)}</strong>

                                                            </>
                                                        </td>
                                                        <td className="acc-product-info">
                                                            <div className={v.backOrderedQuantity > 0 ? "bs5 row" : "bs5 row d-none"}>
                                                                <div className="col-8">Backordered:</div>
                                                                <div className="col-4 text-end">{v.backOrderedQuantity}</div>
                                                            </div>
                                                            <div className="bs5 row">
                                                                <FactoryLeadTimeDisplay
                                                                    single_product={cartProductData && cartProductData[v.itemNumber]}
                                                                    single_product_inventory={cartProductInventoryData && cartProductInventoryData[v.ERPPartNumber]}
                                                                    isAdditionalLead={true} />
                                                            </div>

                                                            <div className="mb-3">
                                                                {v.scheduleDetails.length > 0 &&
                                                                    <>
                                                                        <span className="">Scheduled Dates:</span>
                                                                        <div className="sceduledate-list border-bottom1 mb-1">
                                                                            <div className="d-flex  border-bottom1 justify-content-between">
                                                                                <div className="col-4 ps-0">Quantity</div>
                                                                                <div className="col-8 pe-0 text-end">Ship Date</div>
                                                                            </div>
                                                                            {getAvailableQuantity(v) > 0 ?
                                                                                <div className="bs5 row m-0">
                                                                                    <div className="col-4 ps-0">{getAvailableQuantity(v)}</div>
                                                                                    <div className="col-8 pe-0 text-end">
                                                                                        As Available
                                                                                </div>
                                                                                </div> : null}
                                                                            {v.scheduleDetails.map((p, j) => (
                                                                                <div className="bs5 row m-0" key={j}>
                                                                                    <div className="col-4 ps-0">{p.quantity}</div>
                                                                                    <div className="col-8 pe-0 text-end">
                                                                                        {Helper.dateFormatFromString(p.scheduledDate, true)}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="acc-product-total">
                                                            <div className="bs5 row">
                                                                <div className="col-4">Unit Price:</div>
                                                                <div className="col-8 text-end text-right">{Helper.getFormatNumber(Number(v.unitPrice), window.mct, window.mcs, 5)}</div>
                                                            </div>
                                                            <div className="bs5 row">
                                                                <div className="col-4">Subtotal:</div>
                                                                <div className="col-8 text-end">{Helper.getFormatNumber(Number(v.subtotal), window.mct, window.mcs)}</div>
                                                            </div>
                                                            <div className="bs5 row">
                                                                <div className="col-4">Quantity:</div>
                                                                <div className="col-8 text-end text-right">{v.quantity}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}

export default CheckoutMyCart;